<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <!-- <el-form-item label="类型：">
        <el-select v-model="query.commissionSource" placeholder="请选择" clearable size="small">
          <el-option label="学费" :value="0"></el-option>
          <el-option label="课程" :value="7"></el-option>
          <el-option label="会议" :value="8"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="加盟类型：" v-if="+commissionSource === 1">
        <el-select v-model="query.jmLevel" placeholder="请选择" clearable size="small">
          <el-option label="体验班" :value="7"></el-option>
          <el-option label="研修班" :value="6"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="加盟方式：" v-if="+commissionSource === 1">
        <el-select v-model="query.source" placeholder="请选择" clearable size="small">
          <el-option label="本人申请" :value="1"></el-option>
          <el-option label="业务员申请" :value="0"></el-option>
          <el-option label="后台提交" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="绑定业务员：">
        <el-select v-model="query.ywId" filterable placeholder="请选择业务员" :filter-method="businessFilter" clearable size="small" @blur="getBusinessList()">
          <el-option :label="`${item.name}（${item.levelName}）`" :value="item.id" v-for="item in businessList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="绑定技术老师：">
        <el-select v-model="query.technicianId" filterable placeholder="请选择技术老师" clearable size="small" :filter-method="technicianFilter" @blur="getTechnicianList()">
          <el-option :label="`${item.realName}（${item.levelName}）`" :value="item.id" v-for="item in technicianList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="加盟时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import sysGoodsApi from '@/api/goods/sysGoods'
import educationCompanyApi from '@/api/education'
import technicianInfoApi from '@/api/technical/technicianInfo'
import clientListApi from '@/api/client/clientList'
import { filterEmpty } from '@/utils'
export default {
  props: ['isIntegral', 'commissionSource'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
      },
      technicianList: [],
      businessList: [],
    }
  },
  created() {
    this.getTechnicianList()
    this.getBusinessList()
  },
  methods: {
    businessFilter(e) {
      this.getBusinessList(e)
    },
    technicianFilter(e) {
      this.getTechnicianList(e)
    },
    // 获取技术老师列表
    getTechnicianList(e) {
      let obj = {
        status: 10,
        pageNo: 1,
        pageSize: 100,
        realName: e
      }
      technicianInfoApi.fetchList(obj).then(({
        data
      }) => {
        this.technicianList = data.list
      })
    },
    // 获取业务员列表
    getBusinessList(e) {
      let obj = {
        customerTypes: 2,
        isGetAllParent: true,
        isDeparted: 0,
        pageNo: 1,
        pageSize: 100,
        name: e
      }
      clientListApi.getListPageForMini(obj).then(({
        data
      }) => {
        this.businessList = data.list
      })
    },
    handleDownload() {
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      let query = filterEmpty(this.query)
      console.log(this.commissionSource)  
      if (+this.commissionSource != 1) query.commissionSource = +this.commissionSource
      let Ins = +this.commissionSource === 1 ? educationCompanyApi.findEducationExport : educationCompanyApi.educationCourserOrMeetingExport;
      return this.$common.confirm('是否确认导出')
        .then(() => Ins(filterEmpty(query))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    },

  }

}
</script>

<style>
</style>
